module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/asset_fiscal.a3ed015d.png";